<template>
  <div class="inner-wrapper">
    <nuxt />
  </div>
</template>

<script>

export default {
  middleware: [
    'fetchUser',
    'applicationForm'
  ]
}
</script>

<style lang="scss" scoped>

</style>
